import { all } from "redux-saga/effects";
import AuthSaga from "./auth/saga";
import UsersSaga from "./users/saga";
import RolesSaga from "./roles/saga";
import UploadsSaga from "./uploads/saga";
import VendorsSaga from "./vendors/saga";
import ChannelPartnersSaga from "./channelPartners/saga";
import DataCategoriesSaga from "./dataCategories/saga";
import ProjectsSaga from "./projects/saga";
import LeadSourcesSaga from "./leadSources/saga";
import PermissionsSaga from "./permissions/saga";
import DashboardSaga from "./dashboard/saga";
import PowerBISaga from "./powerbi/saga";
import ClusterSaga from "./cluster/saga";
import ExtractionsSaga from "./extractions/saga";
import ExtDataGroupsSaga from "./extDataGroups/saga";
import ExtDataCategoriesSaga from "./extDataCategories/saga";
import ExtExclusionsSaga from "./extExclusions/saga";
import ExtCustomColumnsSaga from "./extCustomColumns/saga";
import ExtCustomColumnQueriesSaga from "./extCustomColumnQueries/saga";
import ExtVersionsSaga from "./extVersions/saga";
import ExtOutputMappingsSaga from "./extOutputMappings/saga";
import MultiChannelCampaignsSaga from "./mcc/saga";


export default function* rootSaga() {
    yield all([
        AuthSaga(),
        UsersSaga(),
        RolesSaga(),
        PermissionsSaga(),
        VendorsSaga(),
        ChannelPartnersSaga(),
        DataCategoriesSaga(),
        ProjectsSaga(),
        LeadSourcesSaga(),
        UploadsSaga(),
        DashboardSaga(),
        PowerBISaga(),
        ClusterSaga(),
        ExtractionsSaga(),
        ExtDataGroupsSaga(),
        ExtDataCategoriesSaga(),
        ExtExclusionsSaga(),
        ExtCustomColumnsSaga(),
        ExtCustomColumnQueriesSaga(),
        ExtVersionsSaga(),
        ExtOutputMappingsSaga(),
        MultiChannelCampaignsSaga(),
    ]);
}
